// extracted by mini-css-extract-plugin
module.exports = {"option":"KnownSwitch_option__3XDTq","lastOption":"KnownSwitch_lastOption__F1_NR","optionLabel":"KnownSwitch_optionLabel__39Gdk"};